import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'EDUCATION_UPDATE',
    smsDelete : 'EDUCATION_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        education:[],
        education_detail:{},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        educationLoading: false,
        educationError: false,  
       
        ...store
    },

    mutations : {
        ...mutations,

        SET_EDUCATION(state, education) {
            state.education = education;
        },

        SET_EDUCATION_DETAIL(state, detail) {
            state.education_detail = detail;
        },

        EDUCATION_LOADING (state, loading) {
            state.educationLoading = loading;
        },

        EDUCATION_ERROR (state, hasError) {
            state.educationError = hasError;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
        // Education
        async addEducation ({commit, dispatch}, payload) {
            commit('EDUCATION_LOADING', true);
            commit('EDUCATION_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.post(V1API.create_education, payload.education, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchEducation')
                return response

            } catch (e) {
                commit('EDUCATION_ERROR', true);
            } finally {
                commit('EDUCATION_LOADING', false);
            }
        },

        async fetchEducationDetail ({ commit },payload) {
            commit('EDUCATION_LOADING', true);
            commit('EDUCATION_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.get_education_details + payload, config);
                let response = result.data.data
                commit('SET_SLIDER_DETAIL', response);

            } catch(error) {
                commit('EDUCATION_ERROR', true);
            } finally {
                commit('EDUCATION_LOADING', false);
            }
        },

        async fetchEducation ({ commit }) {
            commit('EDUCATION_LOADING', true);
            commit('EDUCATION_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let result = await axios.get(V1API.education_list, config);
                let response = result.data
                commit('SET_EDUCATION', response.data);

            } catch(error) {
                commit('EDUCATION_ERROR', true);
            } finally {
                commit('EDUCATION_LOADING', false);
            }
        },
    
        async updateEducation ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_education+payload.id, payload.education, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchEducation')
                return response

            } catch (e) {
                commit('EDUCATION_ERROR', true);
            } finally {
                commit('EDUCATION_LOADING', false);
            }
        },
        
        async deleteEducation({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.education_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchEducation')
            return response
        }
    },

    getters: {}
}
